import { render, staticRenderFns } from "./AlcoholNicheIcon.vue?vue&type=template&id=674f865b&scoped=true"
import script from "./AlcoholNicheIcon.vue?vue&type=script&lang=js"
export * from "./AlcoholNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f865b",
  null
  
)

export default component.exports